(function ($) {
    $(function () {
        const $loadMoreWrapper = $('.loadMore');

        $loadMoreWrapper.on('click', '.button', function () {

            $button = $(this);
            $button.addClass('loading');
            var page = $button.data('page');

            // load more posts with ajax based on current filter state and page number
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'load_more_articles',
                    type: 'post',
                    terms: activeTerms || {},
                    page: page,
                    nonce: $button.data('nonce'),
                },
                success: function (res) {
                    // get actual button top position
                    var buttonTop = $button.offset().top;

                    $('.entries').append(res.posts);

                    // scroll to appended posts (last button top position)
                    $('html, body').animate({
                        scrollTop: buttonTop,
                    }, 500);

                    // remove loading class
                    $button.removeClass('loading');

                    // hide load more button if no more posts
                    if (res.more == false) {
                        $button.hide();
                    } else {
                        // update page number
                        $button.data('page', page + 1);

                        // show load more button
                        $button.show();
                    }
                },
            });
        });
    });
})(jQuery);
